import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PermissionService } from './service/permission.service';



@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ],
  providers: [
    PermissionService,
  ]
})
export class PermissionModule { }
